import { Control, useController } from "react-hook-form";
import { SystemCode } from "utils/engine/consts";
import useTranslation from "utils/hooks/useTranslation";

interface SolutionRadioProps {
  name: string;
  control: Control<any>;
  systeme?: string | null;
  options: Array<{
    value: string;
    puissance: number;
    references_commerciales: EtudeReferenceCommerciale[];
    optimale: boolean;
  }>;
}

export const SolutionRadio: React.FC<SolutionRadioProps> = ({
  control,
  name,
  systeme,
  options,
}) => {
  const { field } = useController({ control, name });
  const type =
    systeme === SystemCode.ECHANGEUR_BALLONS_ECS ? "exchange" : "stockprep";
  const { t } = useTranslation();

  return (
    <group
      data-radius="5"
      data-contain=""
      data-gap="1"
      data-border=""
      data-width="auto"
      data-name="interactive_grid"
    >
      <group data-align="center" data-space="10" data-gap="5" data-border="">
        <group
          data-length="30"
          data-align="center"
          data-justify="center"
          data-space="5"
          data-gap="5"
        ></group>
        <separator data-vertical="" data-height="20"></separator>
        <group
          data-length="120"
          data-align="center"
          data-justify=""
          data-space="5"
          data-gap="5"
        >
          <text data-wrap="wrap">{t("FO_ETU_POWER_HP_ECS")}</text>
        </group>
        {systeme == SystemCode.ECHANGEUR_BALLONS_ECS ? (
          <group
            data-length="220"
            data-align="center"
            data-justify=""
            data-space="5"
            data-gap="5"
          >
            <text>{t("FO_RESULT_EXCHANGE")}</text>
          </group>
        ) : (
          <group
            data-length="220"
            data-align="center"
            data-justify=""
            data-space="5"
            data-gap="5"
          >
            <text>{t("FO_RESULT_PREP_BUFFER")}</text>
          </group>
        )}

        <group
          data-length="220"
          data-align="center"
          data-justify=""
          data-space="5"
          data-gap="5"
        >
          <text>{t("FO_SIMULATION_DHW_TANK_1")}</text>
        </group>
        <group
          data-length="220"
          data-align="center"
          data-justify=""
          data-space="5"
          data-gap="5"
        >
          <text>{t("FO_SIMULATION_DHW_TANK_2")}</text>
        </group>
      </group>
      {options.map((o: any) => (
        <label
          data-type="group"
          data-align="center"
          data-space="10"
          data-gap="5"
        >
          <group
            data-length="30"
            data-align="center"
            data-justify="center"
            data-space="5"
            data-gap="5"
          >
            <label data-align="center" data-type="group">
              <input
                type="radio"
                value={o.value}
                name={field.name}
                onChange={(e: any) => {
                  field.onChange(e.target.value);
                }}
                checked={field.value === o.value}
                ref={field.ref}
              />
            </label>
          </group>
          <separator data-vertical="" data-height="20"></separator>
          <group
            data-length="120"
            data-align="center"
            data-justify=""
            data-space="5"
            data-gap="5"
          >
            <text>{o.puissance} kW</text>
            {o.optimale && (
              <group
                data-length="5"
                data-align="center"
                data-justify=""
                data-space-left="10"
              // data-gap="5"
              >
                <icon data-fill data-color="main">
                  star
                </icon>
              </group>
            )}
          </group>
          {o.references_commerciales
            .sort((a: any) => (a.type === type ? -1 : 1))
            .map((rc: any) => (
              <>
                <separator data-vertical="" data-height="20"></separator>
                <group
                  data-length="220"
                  data-align="center"
                  data-justify=""
                >
                  <text>{systeme === SystemCode.ECHANGEUR_BALLONS_ECS ? rc.display_name : rc.label}</text>
                </group>
              </>
            ))}
        </label>
      ))}
    </group>
  );
};
